import type { SERP_IDS } from "app/pages/website-analysis/traffic-sources/search/components/serp/SerpTypes";
import type { ITableCellProps } from "app/components/React/Table/interfaces/ITableCellProps";

export enum ESERPMetaType {
    ORGANIC = "organic",
    FEATURE = "feature",
}

export interface IRecord {
    serpFeature: string;
    currentPosition?: number;
    favicon?: string;
    innerPosition?: number;
    previousPosition?: number;
    site?: string;
    title?: string;
    url?: string;
}

export interface ISERPRecord {
    currentPosition?: number;
    previousPosition?: number;
    records?: IRecord[];
    serpFeature: string;
}

export type SERPRecords = Partial<Record<SERP_IDS, ISERPRecord>>;

export interface ISERPTableServerResponse {
    records: IRecord[];
    serpRecords: SERPRecords;
    lastScrapeDate: string;
}

export type IRecordWithType = IRecord & { type: ESERPMetaType };

export type SERPSnapshotCellProps = ITableCellProps & {
    onCellClick: (event: Event, rowIndex: number) => void;
    hideUrl?: boolean;
};
